import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Container,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import {
  headerText,
  loginForm,
  logo,
  mainContainer,
  welcomeText,
} from "./styles";
import MuiInput from "../../components/UIKit/Input";
import MuiPassword from "../../components/UIKit/InputPassword";
import { useFormik } from "formik";
import { SignInValidations } from "../../utils/validation";
import { useLoginMutation } from "../../RTKQuery/AuthService/authApi";
import fwlogo from "../../assets/images/flavorwiki-logo-blue.png";

const Login = () => {
  const [login, { isLoading }] = useLoginMutation();
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();
  const data = useSelector((state) => state.userValidation);
  const formik = useFormik({
    initialValues: {
      username: "",
      password: "",
    },
    validationSchema: SignInValidations,
    onSubmit: async (values) => {
      try {
        const response = await login(values).unwrap();
        if (response) {
          localStorage.setItem("token", response.access_token);
          navigate("/campaigns");
        }
      } catch (error) {
        if (error.status === 401) {
          setError("Incorrect email or password");
        } else {
          setError("Something went wrong");
        }
      }
    },
  });

  const handleClickShowPassword = () => setShowPassword(!showPassword);

  useEffect(() => {
    if (data?.error) {
      setError(data?.error);
    } else if (data?.token) {
      navigate("/campaigns");
    }
  }, [data, navigate]);
  const handleSubmit = async (e) => {
    e.preventDefault();
    formik.setTouched({
      username: true,
      password: true,
    });

    const errors = await formik.validateForm();
    if (Object.keys(errors).length === 0) {
      formik.handleSubmit(e);
    }
  };

  return (
    <Container sx={mainContainer}>
      <Box style={{ position: "relative" }}>
        <img style={logo} src={fwlogo} alt="FlavorWiki Logo" />
        <Typography
          sx={{
            position: "absolute",
            bottom: "-15px",
            right: "0",
            color: "gray",
            fontSize: "12px",
            fontWeight: 500,
            color: "#367598",
          }}
        >
          Marketing
        </Typography>
      </Box>
      <Box sx={loginForm} component="form" onSubmit={handleSubmit}>
        <Box sx={headerText}>
          <Typography sx={welcomeText}>Welcome Back</Typography>
          <Typography
            sx={{ color: "gray", textAlign: "center", margin: "0" }}
            variant="caption"
            noWrap
          >
            Enter your credentials to access your account.
          </Typography>
        </Box>
        <MuiInput
          label="Email"
          placeholder="Enter your Email address"
          fieldProps={formik.getFieldProps("username")}
          error={formik.touched.username && Boolean(formik.errors.username)}
          helperText={formik.touched.username && formik.errors.username}
        />
        <MuiPassword
          label="Password"
          fieldProps={formik.getFieldProps("password")}
          error={formik.touched.password && Boolean(formik.errors.password)}
          helperText={formik.touched.password && formik.errors.password}
          showPassword={showPassword}
          handleClickShowPassword={handleClickShowPassword}
        />
        <Button
          type="submit"
          color="primary"
          sx={{ width: "100%", color: "white" }}
          variant="contained"
          disabled={isLoading}
        >
          {isLoading ? (
            <CircularProgress
              size={28}
              sx={{ color: "primary" }}
              thickness={7}
            />
          ) : (
            "Sign In"
          )}
        </Button>
        {error && <Alert severity="error">{error}</Alert>}
      </Box>
    </Container>
  );
};

export default Login;
